// ─────────────────────────────────────────────────────────────────────────────
// VITALITY SERVICES — FIREBASE CONFIGURATION
// ─────────────────────────────────────────────────────────────────────────────
// SETUP INSTRUCTIONS:
// 1. Go to https://console.firebase.google.com
// 2. Click "Add project" → name it "vitality-services"
// 3. Go to Project Settings → General → Your apps → Add app → Web (</>)
// 4. Register app name "Vitality Web App"
// 5. Copy the firebaseConfig values below and replace the placeholders
// 6. In Firebase console: Enable Authentication → Email/Password
// 7. In Firebase console: Enable Firestore Database → Start in production mode
// 8. In Firebase console: Enable Storage (for photos)
// ─────────────────────────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getFunctions } from 'firebase/functions';

// ⬇️ REPLACE THESE WITH YOUR ACTUAL VALUES FROM FIREBASE CONSOLE
const firebaseConfig = {
apiKey:            "AIzaSyBad0ms2menEY2QkPg32D1m3CNLzfD9_yw",
authDomain:        "vitality-services.firebaseapp.com",
projectId:         "vitality-services",
storageBucket:     "vitality-services.firebasestorage.app",
messagingSenderId: "786419681875",
appId:             "1:786419681875:web:e7f478350220f2e26094a6",
measurementId:     "G-VC94WVPJMM"
};

// Initialize
const app = initializeApp(firebaseConfig);

export const auth     = getAuth(app);
export const db       = getFirestore(app);
export const storage  = getStorage(app);
export const functions = getFunctions(app);

// Messaging only works in supported browsers (not Safari on iOS currently)
export const messaging = (async () => {
  const supported = await isSupported();
  return supported ? getMessaging(app) : null;
})();

export default app;
